<i18n>
{
  "fr": {
    "submit": "Personnaliser",
    "go": "GO"
  }
}
</i18n>

<template>
  <div class="cups-selection">
    <ul class="cups-selection__list">
      <li
        v-for="(cup, index) in cups"
        :key="index"
        :class="[
          'cups-selection__cup',
          { 'cups-selection__cup--active': cup.key === selectedCup },
        ]"
        @click="onClick(cup, index)"
      >
        <input
          :id="`cup${index}`"
          type="radio"
          name="cup.key"
          class="cups-selection__radio"
          :value="cup.key"
          :checked="index === 0"
        />
        <label :for="`cup${index}`" class="cups-selection__cup-label">
          <img
            :src="cup.image"
            alt=""
            class="cups-selection__cup-image"
            loading="lazy"
          />
          <div class="cups-selection__shadow"></div>
        </label>
      </li>
    </ul>

    <div class="cups-selection__personalize" :style="btnTranslateX">
      <button
        class="base-btn cups-selection__personalize-btn"
        @click="redirectToConfigurator()"
      >
        {{ $t('submit') }}
      </button>

      <button
        class="base-btn cups-selection__arrow-btn icon icon--arrow-right-2"
        @click="redirectToConfigurator()"
      >
        {{ $t('go') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CupsSelection',
  props: {
    configuratorUrl: {
      type: String,
      default: undefined,
    },
    cups: {
      type: Object,
      required: true,
    },
    cmsUrl: {
      type: String,
      default: undefined,
    },
  },
  data: function () {
    return {
      selectedCup: this.cups[0],
      btnTranslateXValue: 0,
    };
  },
  computed: {
    btnTranslateX() {
      return `transform: translateX(${this.btnTranslateXValue}%);`;
    },
  },
  methods: {
    redirectToConfigurator() {
      if (this.configuratorUrl) {
        const joinCharacter =
          -1 !== this.configuratorUrl.indexOf('?') ? '&' : '?';
        window.location =
          this.configuratorUrl +
          joinCharacter +
          'sizeId=' +
          this.selectedCup.id;
      } else {
        window.location = this.cmsUrl + this.selectedCup.pathCms;
      }
    },
    onClick(cup, index) {
      this.selectedCup = cup;
      this.btnTranslateXValue = index * 100;
    },
  },
};
</script>
